import { React, useState, useEffect } from 'react'
import styles from './GenderAgePanel.module.scss'
import ColumnChart from '../../components/ColumnChart'
import GenderAge from '../../components/ColumnChart/GenderAgeDetails'
import { useGeoFetch,useGeoState } from '../../components/GeoProvider'
import ErrorMessage from '../../components/Layout/ErrorMessage'
import Spinner from '../../components/Loader/Spinner'

const Databind = ({ data }) => {
    const {
    displayDate,
    setDisplayDate
    
  } = useGeoState()

// const toTime = (s) => new Date(s).getTime();

// const latest = data.reduce((best, cur) =>
//   !best || toTime(cur.week_ending) > toTime(best.week_ending) ? cur : best
// , null);

// let filtered=null
const toYMD = (dateStr) => new Date(dateStr).toISOString().slice(0, 10);
// if (displayDate>latest.week_ending) {
//   filtered = data.filter(d => toYMD(d.week_ending) === latest.week_ending);
//   setDisplayDate(latest.week_ending);
// }
// else
 const filtered = data.filter(d => toYMD(d.week_ending) === displayDate);
  return (
    <div>
          {filtered !== undefined && filtered.length > 0 ? (
            <>
              <ColumnChart data={filtered} chartName="utiGenderAgechart" renderType="dashboard" />
              <GenderAge  data={filtered} chartName="utiGenderAgechart" ></GenderAge>
            </>
          ) : <Spinner/>}
        </div>
  )
}

const GenderAgePanel = ({ geo_parent,geo_type, geo_id, data_type }) => {    
  const {
    dataStartDate,
    dataEndDate,
    setDisplayDate
  } = useGeoState()
  const [genderAge, setGenderAge] = useState()
  const [errorCode, setErrorCode] = useState()
  const [errorMessage, setErrorMessage] = useState()
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
  if(geo_type==='ZIP3')
  {
    var geotype= (geo_type==='ZIP3' && geo_id ===undefined) ? "STATE": 'ZIP3'
    geo_id = (geo_type==='ZIP3' && geo_id ===undefined) ? geo_parent:geo_id
    geo_type = geotype
  }
  var genderendpoint = 'utigenderagedetails' 
  const { data: genderAgeData, error: genderAgeDataError } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    genderendpoint,
    geo_type + '/' + geo_id,
    {geo_type:geo_type, geo_id:geo_id},
    'POST'
  )

  useEffect(() => {
    if (genderAgeData !== null && genderAgeData !== undefined) {
      if (genderAgeData.response_code === 200) { 
        const toTime = (s) => new Date(s).getTime();

        const latest = genderAgeData.response_data.reduce((best, cur) =>
        !best || toTime(cur.week_ending) > toTime(best.week_ending) ? cur : best
        , null);    
        setDisplayDate(latest.week_ending)         
        setGenderAge(genderAgeData.response_data)
      } else {
        setErrorCode(genderAgeData.response_code)
        setErrorMessage(genderAgeData.response_message)
        setErrorSubject(genderAgeData.response_subject)
        seterrorOccured(true)
      }
    }
  }, [genderAgeData])

  if (genderAgeDataError || errorOccured) {
    return (
      <ErrorMessage
        errorCode={errorCode}
        errorMessage={''}
        errorSubject={errorSubject}
        errorDetails={errorMessage}
      />
    )
  }

  return genderAge!==undefined ? (
    <div className={styles.base}>
      <div className={styles.maindivFormat}>
        <div>
          <span className={styles.captionFormat}>
            Age & Gender
            {/* {data_type==="COVID"?<p className={styles.subCaptionFormat}>
            Age and gender of individuals with COVID-19 during the last year.
            </p>:<p className={styles.subCaptionFormat}>
            Age and gender of individuals with {data_type.toUpperCase()==='FLU'?'flu':data_type} during the current respiratory disease season.
            </p>} */}
          </span>
        </div>

        <div>
          {genderAge !== undefined ? (
            <Databind data={genderAge} />
          ) : <Spinner/>}
        </div>
      </div>
    </div>
  ) : <Spinner/>
}

export default GenderAgePanel
